@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.price
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.web.dto.cartypes.CarTypeDto
import com.narbase.letsgo.web.dto.rides.RideRouteDto

class PriceDataDto (
    val actualRidePrice: Int,
    val payablePrice: Int,
    val totalDiscount: Int,
    val promoDiscount: Int,
    val balanceDiscount: Int,
    val callCenterCost: Int,
    val distanceInKm: Double,
    val durationInMin: Double,
    val pickupLat: Double,
    val pickupLng: Double,
    val destLat: Double,
    val destLng: Double,
    val createdOn: KmmLong,
    val currencyId: Int,
    val currencyName: String,
    val carTypeId: Int?,
    val requestedCarTypeId: Int?,
    val flagDown: Double?,
    val flagDownCommission: Double?,
    val markup: Double?,
    val markupCommission: Double?,
    val profileGroupAdjustment: Double?
)


class ExtendedPriceDataDto(
    val priceData: PriceDataDto?,
    val token: String?,
    val carType: CarTypeDto?
)

class ExtendedPriceDataWithRouteDto(
    val extendedPriceData: ExtendedPriceDataDto,
    val rideRoute: RideRouteDto?,
)